import { gql } from '@apollo/client';

export const GET_CM_AND_EDITORS = gql`
  {
    usersContentManagersOrEditors {    
      id
      name
      email
      role
    }
  }
`;

export const GET_WRITERS = gql`
  {
    userWriters {
      id
      name
      email
      role
    }
  }
`;

export const GET_USER_BY_ID = gql`
  query user($id: String!) {
    user(id: $id) {
      id
      name
      email
      status
      canPublish
    }
  }
`;

export const CREATE_USER = gql`
  mutation createUser($name: String!, $email: String!, $password: String!, $role: String!) {
    createUser(input: { name: $name, email: $email, password: $password, role: $role }) {
      id
      name
      email
      role
    }
  }
`;

export const EDIT_CLIENT = gql`
  mutation updateUser($id: String!, $name: String!,$email: String!, $password: String) {
    updateUser(id: $id, input: { name: $name, email: $email, password: $password }) {
      id
      name
      email
      role
    }
  }
`;

export const EDIT_USER = gql`
  mutation updateUser($id: String!, $name: String!,$email: String!, $password: String, $role: String!) {
    updateUser(id: $id, input: { name: $name, email: $email,password: $password,role: $role }) {
      id
      name
      email
      role
    }
  }
`;

export const DELETE_USER = gql`
  mutation deleteUser($id: String!) {
    deleteUser(id: $id) {
      id
    }
  }
`;

export const GET_REVIEWERS_WRITERS_TRANSLATORS = gql`
  query {
    userListByRole(input: { roles: ["REVIEWER", "WRITER", "TRANSLATOR"] }) {
      name
      id
      role
    }
  }
`;

export const GET_ACCOUNT_MANAGERS = gql`
  query {
    userListByRole(input: { roles: ["ADMIN", "ACCOUNTMANAGERFACEBOOK", "ACCOUNTMANAGERGOOGLE", "ACCOUNTMANAGERTABOOLA"] }) {
      id
      email
      name
      role
    }
  }
`;
